import { render, staticRenderFns } from "./dataPanel.vue?vue&type=template&id=3eb740cc&scoped=true&"
import script from "./dataPanel.vue?vue&type=script&lang=js&"
export * from "./dataPanel.vue?vue&type=script&lang=js&"
import style0 from "./dataPanel.vue?vue&type=style&index=0&id=3eb740cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb740cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb740cc')) {
      api.createRecord('3eb740cc', component.options)
    } else {
      api.reload('3eb740cc', component.options)
    }
    module.hot.accept("./dataPanel.vue?vue&type=template&id=3eb740cc&scoped=true&", function () {
      api.rerender('3eb740cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dataPanel.vue"
export default component.exports